export default {"src":"/_next/static/image/src/images/about/icons/twitter.9f217e788f15b16979c26f93963e111b.svg","height":24,"width":25};